import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InfoDeviceState {
  data: any;
  isLoading: boolean;
  error: string | null;
}

const initialState: InfoDeviceState = {
  data: [],
  isLoading: false,
  error: null,
};

const infoDeviceSlice = createSlice({
  name: 'infoDevices',
  initialState,
  reducers: {
    setInfoDevices: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setInfoDevicesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setInfoDevicesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setInfoDevices, setInfoDevicesLoading, setInfoDevicesError } = infoDeviceSlice.actions;

export default infoDeviceSlice.reducer;
